// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card.clickable {
  cursor: pointer;
}
ion-card.clickable:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

ion-card.selected {
  border: 2px solid var(--ion-color-primary);
  background-color: rgba(var(--ion-color-primary-rgb), 0.1);
}

ion-card.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

ion-text {
  font-size: 0.6rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/gastos/expense-type-selector.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;AACI;EACI,oCAAA;AACR;;AAGA;EACI,0CAAA;EACA,yDAAA;AAAJ;;AAGA;EACI,YAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ","sourcesContent":["ion-card.clickable {\r\n    cursor: pointer;\r\n\r\n    &:hover {\r\n        background-color: rgba(0, 0, 0, 0.1);\r\n    }\r\n}\r\n\r\nion-card.selected {\r\n    border: 2px solid var(--ion-color-primary);\r\n    background-color: rgba(var(--ion-color-primary-rgb), 0.1);\r\n}\r\n\r\nion-card.disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n}\r\n\r\nion-text {\r\n    font-size: 0.6rem;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
